

















import { Vue, Component, Prop } from 'vue-property-decorator';
import axios from 'axios';
// import XGplayer from '../components/XGplayer.vue';
import XGplayer from '@/components/XGplayer.vue';

@Component({
  components: {
    XGplayer,
  },
})
export default class Rule extends Vue {
  newsDetail: any = {};
  thisTime: any;
  async mounted() {
    const classId = this.$route.query.classid;
    const newsId = this.$route.query.newid;
    console.log('clss:', classId, newsId);
    axios({
      method: 'get', // HTTP请求方法，可以是get、post等
      url: `https://newsapi.cqcb.com/v1/detail?columnId=${classId}&newsId=${newsId}`, // 第三方API地址
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then((response) => {
        // 处理响应数据
        console.log(response.data.data);
        this.timeformat(response.data.data.lastDoTime);
        const contentstr = response.data.data.originNewstext;
        const usrname = response.data.data.userName
          ? response.data.data.userName
          : response.data.data.newUserName;
        this.newsDetail = {
          title: response.data.data.title,
          time: this.thisTime,
          smalltext: response.data.data.smallText,
          content: contentstr + '<p>编辑：' + usrname + '</p>',
          videourl: response.data.data.videoUrl,
          videocover: response.data.data.titlePic,
        };
      })
      .catch((error) => {
        // 处理错误
        console.error(error);
      });
  }
  timeformat(timestamp: any) {
    // 使用Date对象将时间戳转换为日期
    const date = new Date(timestamp * 1000);

    // 获取日期的各个部分（年、月、日、时、分、秒）
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // 月份从0开始，所以要加1
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // 创建一个日期格式的字符串
    const dateString = `${year}-${month
      .toString()
      .padStart(2, '0')}-${day
      .toString()
      .padStart(2, '0')} ${hours
      .toString()
      .padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;

    this.thisTime = dateString;
  }
}
